import { render, staticRenderFns } from "./AllocationModal.vue?vue&type=template&id=74e1b238&scoped=true&"
import script from "./AllocationModal.vue?vue&type=script&lang=js&"
export * from "./AllocationModal.vue?vue&type=script&lang=js&"
import style0 from "./AllocationModal.vue?vue&type=style&index=0&id=74e1b238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e1b238",
  null
  
)

export default component.exports